export const useMenuStore = defineStore('menu', {
	state: () => ({
		isOpen: false,
		isDesktop: import.meta.client ? window.innerWidth > 992 : false,
		isScrolled: false,
	}),
	actions: {
		toggleOpen() {
			this.isOpen = !this.isOpen
		},
	},
})
